import React, { useRef, useEffect, useState } from "react";
import { CSSTransitionGroup } from "react-transition-group";

import Post from "./Post.jsx";

const SlidingPost = ({
  post,
  animationDuration = 1000,
  maxPostCommentLength = 300,
}) => {
  const postRef = useRef(null);
  const [height, setHeight] = useState(null);

  useEffect(() => {
    const { height } = postRef.current?.getBoundingClientRect() || {
      height: null,
    };
    if (height) {
      setHeight(height);
    }
  }, [post]);

  return (
    <div style={{ ...(height && { height }) }}>
      <CSSTransitionGroup
        transitionName="post"
        transitionEnterTimeout={animationDuration}
        transitionLeaveTimeout={animationDuration}
        component="div"
        className="relative w-screen"
      >
        {post && (
          <Post
            {...post}
            key={post.id}
            ref={postRef}
            maxCommentLength={maxPostCommentLength}
          />
        )}
      </CSSTransitionGroup>
    </div>
  );
};

export default SlidingPost;
